/* <brand-directory> — Markalar / Tüm kategoriler sekmeleri (#markalar · #kategoriler) ve A–Z harf filtresi */
if (!customElements.get('brand-directory')) {
  class BrandDirectory extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.show(tab.dataset.view, true);
        });
        tab.addEventListener('keydown', (e) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
          e.preventDefault();
          const next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
          this.show(next.dataset.view, true);
          next.focus();
        });
      });

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-letter-filter]');
        if (btn && !btn.disabled) this.filter(btn.dataset.letterFilter);
      });

      const hash = window.location.hash.slice(1);
      const fromHash = { markalar: 'brands', kategoriler: 'categories' }[hash];
      this.show(fromHash || this.dataset.defaultView || 'brands', false);
    }

    show(view, updateHash) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.view === view;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on) {
          const crumb = this.querySelector('[data-view-crumb]');
          if (crumb) crumb.textContent = tab.textContent.trim();
        }
      });
      this.querySelectorAll('[data-view-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.viewPanel === view));
      this.querySelectorAll('[data-view-text]').forEach((t) => (t.hidden = t.dataset.viewText !== view));
      if (updateHash) {
        const tab = this.tabs.find((t) => t.dataset.view === view);
        if (tab) history.replaceState(null, '', tab.getAttribute('href'));
      }
    }

    filter(letter) {
      this.querySelectorAll('.lc-letters [data-letter-filter]').forEach((b) =>
        b.setAttribute('aria-pressed', b.dataset.letterFilter === letter ? 'true' : 'false')
      );
      let visible = 0;
      this.querySelectorAll('.brand-grid [data-letter]').forEach((item) => {
        const on = !letter || item.dataset.letter === letter;
        item.hidden = !on;
        if (on) visible += 1;
      });
      const featured = this.querySelector('[data-featured]');
      const featuredOn = !!featured && (!letter || featured.dataset.letter === letter);
      if (featured) featured.hidden = !featuredOn;

      const heading = this.querySelector('[data-grid-heading]');
      if (heading) heading.textContent = letter ? this.dataset.letterHeading.replace('__L__', letter) : this.dataset.allHeading;
      const count = this.querySelector('[data-grid-count]');
      const countText = (visible === 1 ? this.dataset.countOne : this.dataset.countOther).replace('__N__', visible);
      if (count) count.textContent = countText;

      const empty = this.querySelector('[data-letter-empty]');
      if (empty) {
        empty.hidden = !(letter && visible === 0 && !featuredOn);
        const text = empty.querySelector('[data-letter-empty-text]');
        if (text) text.textContent = this.dataset.emptyText.replace('__L__', letter);
      }
      const head = this.querySelector('.lc-grid-head');
      if (head) head.hidden = visible === 0;

      const live = this.querySelector('[data-letter-live]');
      if (live) live.textContent = countText;
    }
  }
  customElements.define('brand-directory', BrandDirectory);
}
